module.exports = __webpack_public_path__ + "fonts/Ubuntu-LightItalic.a3ad215.woff";